import React, { useEffect } from 'react';
import { TermsContent } from './TermsContent';

export const TermsModal = ({ open, onClose }) => {
  // Lock background scroll + close on Escape while open
  useEffect(() => {
    if (!open) return;

    const handleKey = (e) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handleKey);
    document.body.style.overflow = 'hidden';

    return () => {
      document.removeEventListener('keydown', handleKey);
      document.body.style.overflow = '';
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center p-0 sm:p-6 bg-black/60 backdrop-blur-sm"
      onClick={onClose}
    >
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="terms-modal-title"
        className="relative w-full h-full sm:h-auto sm:max-h-[90vh] max-w-4xl flex flex-col bg-jp-card sm:rounded-2xl border border-jp-outline/70 shadow-2xl text-left"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="flex items-start justify-between gap-4 px-6 sm:px-8 py-5 border-b border-jp-line">
          <div>
            <p className="text-jp-accent dark:text-jp-gold text-xs font-bold uppercase tracking-widest mb-1">
              Effective Date: 01-July-2026
            </p>
            <h2 id="terms-modal-title" className="text-3xl sm:text-4xl font-anton leading-tight text-jp-ink">
              TERMS OF SERVICE
            </h2>
          </div>
          <button
            type="button"
            onClick={onClose}
            aria-label="Close"
            className="mt-1 p-1 rounded-lg text-jp-muted hover:text-jp-ink hover:bg-jp-section transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-jp-accent"
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        {/* Scrollable body */}
        <div className="flex-1 overflow-y-auto px-6 sm:px-8 py-6 bg-jp-section">
          <TermsContent />
        </div>

        {/* Footer */}
        <div className="px-6 sm:px-8 py-4 border-t border-jp-line flex justify-end">
          <button
            type="button"
            onClick={onClose}
            className="w-full sm:w-auto px-10 py-3 text-sm font-bold uppercase tracking-wider bg-gradient-to-r from-cyan-400 via-cyan-500 to-blue-600 text-slate-900 rounded-xl hover:brightness-110 transition-all shadow-lg shadow-cyan-500/20 focus:outline-none focus-visible:ring-2 focus-visible:ring-jp-accent focus-visible:ring-offset-2 focus-visible:ring-offset-jp-card active:scale-[0.98]"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default TermsModal;
